export const insertUserLinkInText = (huntedUser, postContent, id, innerText) => {
  const postContentWithLink = postContent.replace(
    `@${huntedUser}`,
    `<a href="${window.location.origin}/users/${id}">${innerText}</a>`
  );

  return postContentWithLink;
};
